import React from "react";
import PropTypes from "prop-types";
import { InputField, RadioField, TextareaField } from "../../FormField";

const Part4 = ({ data }) => {
  return (
    <table
      style={{
        margin: "10px 0px",
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #000",
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              backgroundColor: "#edb8be",
              paddingLeft: 10,
              borderBottom: "1px solid #000",
            }}
          >
            IV)&nbsp;HABITS of the EMPLOYEE / ELIGIBLE MEMBER (and DEPENDANT(S) IF APPLICABLE)
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    rowSpan={3}
                    style={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      width: "60%",
                    }}
                  >
                    <div style={{ color: "#f00" }}>
                      Please tick Yes or No.{" "}
                      <span style={{ fontWeight: "bold" }}>
                        If Yes, please provide details in the respective column(s).
                      </span>
                    </div>
                    Please note: Section IV under child(ren) column is not applicable for dependant
                    aged 12 years & below.
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                    colSpan={2}
                  >
                    Employee
                  </td>
                  <td
                    style={{
                      color: "#f00",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      textAlign: "center",
                    }}
                    colSpan={4}
                  >
                    Answer ONLY IF to be insured
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    colSpan={2}
                  >
                    Spouse
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    colSpan={2}
                  >
                    Child(ren)
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                </tr>
                <tr>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              width: "30px",
                            }}
                          >
                            1
                          </td>
                          <td>
                            Have you ever smoked in the last 12 months?
                            <br />
                            If Yes, please provide details of smoking:
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  {Array.of("Emp", "Sp", "Ch").map(key => (
                    <React.Fragment key={key}>
                      <td
                        style={{
                          borderLeft: "1px solid #000",
                          textAlign: "center",
                        }}
                      >
                        <RadioField
                          name={`${key}Smoke`}
                          {...data[`${key}Smoke`]}
                          radioValue="Yes"
                        />
                      </td>
                      <td style={{ borderRight: "1px solid #000", textAlign: "center" }}>
                        <RadioField name={`${key}Smoke`} {...data[`${key}Smoke`]} radioValue="No" />
                      </td>
                    </React.Fragment>
                  ))}
                </tr>
                <tr>
                  <td style={{ borderRight: "1px solid #000" }}>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>&nbsp;</td>
                          <td>a. No. of sticks you smoke per day:</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  {Array.of("Emp", "Sp", "Ch").map(key => (
                    <td
                      key={key}
                      colSpan={2}
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                      }}
                    >
                      <InputField
                        name={`${key}SmokeQuantity`}
                        {...data[`${key}SmokeQuantity`]}
                        style={{ width: 50 }}
                      />
                    </td>
                  ))}
                </tr>
                <tr style={{ borderBottom: "1px solid" }}>
                  <td
                    style={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>&nbsp;</td>
                          <td>b. No. of years since you have been smoking:</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  {Array.of("Emp", "Sp", "Ch").map(key => (
                    <td
                      key={key}
                      colSpan={2}
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                      }}
                    >
                      <InputField
                        name={`${key}SmokeNoOfYears`}
                        {...data[`${key}SmokeNoOfYears`]}
                        style={{ width: 50 }}
                      />
                    </td>
                  ))}
                </tr>

                <tr>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              width: "30px",
                            }}
                          >
                            2
                          </td>
                          <td>
                            Do you consume beer, wine or other alcoholic beverages?
                            <br />
                            If Yes, please furnish details of alcohol consumption:
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  {Array.of("", "Sp", "Ch").map(key => (
                    <React.Fragment key={key}>
                      <td
                        style={{
                          borderLeft: "1px solid #000",
                          textAlign: "center",
                        }}
                      >
                        <RadioField
                          name={`${key}EmpConsumeAlcohol`}
                          {...data[`${key}EmpConsumeAlcohol`]}
                          radioValue="Yes"
                        />
                      </td>
                      <td style={{ borderRight: "1px solid #000", textAlign: "center" }}>
                        <RadioField
                          name={`${key}EmpConsumeAlcohol`}
                          {...data[`${key}EmpConsumeAlcohol`]}
                          radioValue="No"
                        />
                      </td>
                    </React.Fragment>
                  ))}
                </tr>

                <tr>
                  <td style={{ borderRight: "1px solid #000" }}>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>&nbsp;</td>
                          <td>a. Type of alcohol taken:</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  {Array.of("Emp", "Sp", "Ch").map(key => (
                    <td
                      key={key}
                      colSpan={2}
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                      }}
                    >
                      <InputField
                        name={`${key}AlcoholType`}
                        {...data[`${key}AlcoholType`]}
                        style={{ width: 120 }}
                      />
                    </td>
                  ))}
                </tr>
                <tr style={{ borderBottom: "1px solid" }}>
                  <td
                    style={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: 30 }}>&nbsp;</td>
                          <td>b. Average weekly consumption with units of measurement:</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  {Array.of("Emp", "Sp", "Ch").map(key => (
                    <td
                      key={key}
                      colSpan={2}
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                      }}
                    >
                      <InputField
                        name={`${key}AlcoholQuantity`}
                        {...data[`${key}AlcoholQuantity`]}
                        style={{ width: 120 }}
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              width: "30px",
                            }}
                          >
                            3
                          </td>
                          <td>
                            Do you engage in or intend to engage in any sport(s) or occupation of a
                            dangerous / hazardous nature? E.g. scuba / skin diving, motor racing,
                            military / private flying other than as a fare paying passenger,
                            parachuting, etc? If Yes, please state details on the type of sports you
                            participate in:
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  {Array.of("Emp", "Sp", "Ch").map(key => (
                    <React.Fragment key={key}>
                      <td
                        style={{
                          borderLeft: "1px solid #000",
                          textAlign: "center",
                        }}
                      >
                        <RadioField
                          name={`${key}Adventure`}
                          {...data[`${key}Adventure`]}
                          radioValue="Yes"
                        />
                      </td>
                      <td style={{ borderRight: "1px solid #000", textAlign: "center" }}>
                        <RadioField
                          name={`${key}Adventure`}
                          {...data[`${key}Adventure`]}
                          radioValue="No"
                        />
                      </td>
                    </React.Fragment>
                  ))}
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    }}
                  />
                  {Array.of("Emp", "Sp", "Ch").map(key => (
                    <td
                      key={key}
                      colSpan={2}
                      style={{
                        textAlign: "center",
                        borderRight: "1px solid #000",
                      }}
                    >
                      <TextareaField
                        name={`${key}AdventureInfo`}
                        {...data[`${key}AdventureInfo`]}
                        style={{ width: 120 }}
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

Part4.propTypes = {
  data: PropTypes.shape({}),
};

export default Part4;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/GEHD201808/Part4.js